export const typeOfWorkComparator = (t1, t2) => t1.position - t2.position



// WEBPACK FOOTER //
// ./web/js/typesOfWork/utils.js